module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village/levelIcon//2_good.png?v=9e33494d";